/**
 * Pet Groomer module-details request/response shapes.
 * Mirrors backend/src/modules/groomer/groomer.validators.ts.
 */

export type GroomerGender = 'MALE' | 'FEMALE' | 'OTHER';

export type GroomerServiceRadius = 'KM_5' | 'KM_10' | 'KM_15' | 'KM_20';

export type PetSpecies = 'DOG' | 'CAT' | 'BIRD' | 'RABBIT' | 'FISH' | 'OTHER';

export type GroomerDetailsRequest = {
  full_name: string; // 2..120
  date_of_birth: string; // ISO YYYY-MM-DD, groomer must be 18..100
  gender?: GroomerGender;
  salon_name?: string; // 2..120, public salon/studio name (at-salon)
  service_radius: GroomerServiceRadius;
  years_of_experience: number; // 0..80 integer
  groomer_for_species: PetSpecies[]; // 1..6 unique
};

export type GroomerDetailsResponse = {
  id: string;
  vendor_profile_id: string;
  full_name: string;
  date_of_birth: string;
  gender: GroomerGender | null;
  salon_name: string | null;
  service_radius: GroomerServiceRadius;
  years_of_experience: number;
  groomer_for_species: PetSpecies[];
  created_at: string;
  updated_at: string;
};

export const GROOMER_GENDER_OPTIONS: Array<{ value: GroomerGender; label: string }> = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'OTHER', label: 'Other' },
];

export const GROOMER_SERVICE_RADIUS_OPTIONS: Array<{
  value: GroomerServiceRadius;
  label: string;
}> = [
  { value: 'KM_5', label: '5 km' },
  { value: 'KM_10', label: '10 km' },
  { value: 'KM_15', label: '15 km' },
  { value: 'KM_20', label: '20 km' },
];

export const GROOMER_PET_SPECIES_OPTIONS: Array<{ value: PetSpecies; label: string }> = [
  { value: 'DOG', label: 'Dog' },
  { value: 'CAT', label: 'Cat' },
  { value: 'BIRD', label: 'Bird' },
  { value: 'RABBIT', label: 'Rabbit' },
  { value: 'FISH', label: 'Fish' },
  { value: 'OTHER', label: 'Other' },
];
